
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

export default {
name: 'Judgement',
props: {
judge: {},
cuIndex: 0
},
components: {
Group, Cell, Checklist
},
data () {
return {
options: [
{ key: 1, value: '正确' },
{ key: 2, value: '错误' }
],
haOptions: ''
}
},
methods: {
getAnswer () {
return this.judge
},
toggleOption (value) {
if (value) {






this.judge.userAnswer = value[0]

if (value.length > 0 && this.haOptions.length === 0) {



}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Subjects/Judgement/index.vue